import { render, staticRenderFns } from "./base-loader.vue?vue&type=template&id=05ac8e9a&scoped=true&"
import script from "./base-loader.vue?vue&type=script&lang=ts&"
export * from "./base-loader.vue?vue&type=script&lang=ts&"
import style0 from "./base-loader.vue?vue&type=style&index=0&id=05ac8e9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ac8e9a",
  null
  
)

export default component.exports